<rt-dropdown [formGroup]="form" (click)="$event.stopPropagation()" margin-bottom-small-xx>
  <div padding layout-horizontal layout-align-items-center>
    <rt-radio
      [checked]="form.get('dueDateType')!.value === 'relative'"
      [hasLensIcon]="true"
      [hasNoTBMargin]="true"
      [hasColorTextColor]="true"
      (click)="onKindChange('relative')"
      margin-right
    >
      {{ 'app.automated_actions.action_editor.relative' | translate }}
    </rt-radio>
    <rt-radio
      [checked]="form.get('dueDateType')!.value === 'absolute'"
      [hasLensIcon]="true"
      [hasNoTBMargin]="true"
      [hasColorTextColor]="true"
      (click)="onKindChange('absolute')"
    >
      {{ 'app.automated_actions.action_editor.absolute' | translate }}
    </rt-radio>
  </div>
  <rt-divider />
  <div padding-lr padding-tb-small>
    @if (form.get('dueDateType')!.value === 'relative') {
      <rt-form-field>
        <rt-label> {{ relativeLabel() }}: </rt-label>
        <div layout-horizontal>
          <rt-input
            variant="rounded"
            [maxWidth]="'70px'"
            formControlName="dueDateValue"
            type="number"
            [rtForceValidate]="true"
            [rtFormError]="errors"
            margin-right-small
          />
          <rt-select
            [hasSearch]="false"
            [options]="units"
            [required]="true"
            formControlName="dueDateUnit"
            layout-flex-1-1
          />
        </div>
      </rt-form-field>
    }

    @if (form.get('dueDateType')!.value === 'absolute') {
      <rt-date-picker
        [value]="form.get('dueDateDate')!.value"
        [hasNoPadding]="true"
        [selectNowByDefault]="false"
        margin-bottom-small
        (valueChange)="onDateChange($any($event))"
      />
    }
    @if (showTimezone()) {
      <rt-time-zone-picker
        [emit]="false"
        [timezone]="form.get('timezone')!.value"
        (zoneChange)="onZoneChange($event)"
      />
    }
    <rt-button (click)="submit()" [disabled]="!isValid()" variant="primary" margin-top-small>
      <rt-icon name="check" />
      <span>{{ submitLabel() }}</span>
    </rt-button>
  </div>
</rt-dropdown>
